// 仅保存本次详情往返的列表位置和选中ID，不缓存货主资料或审核权限。
let pendingReturn = null;
const scope = (actor, tab, filters) => JSON.stringify([
  String(actor), Number(tab), ...['brand', 'model', 'type', 'supplier', 'clueType'].map(key => String(filters[key] ?? '')),
]);

export function rememberClueListReturn(state) {
  pendingReturn = { ...state, key: scope(state.actor, state.tab, state.filters),
    selectedIds: state.selectedIds.map(String) };
}

export function takeClueListReturn(actor, tab, filters) {
  const state = pendingReturn;
  pendingReturn = null;
  return state?.key === scope(actor, tab, filters) ? state : null;
}

export function clearClueListReturn() {
  pendingReturn = null;
}
